function initFBAnalytics(facebookPixelId) {
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');

  processFbq('init', facebookPixelId);
  // Handled by Angular routing
  // processFbq('track', 'PageView');
}

function fbLogEvent(name, total, currency, items) {
  processFbq('track', name, {
      value: total,
      content_type: 'product',
      currency: currency,
      contents: items
  });
}

function processFbq(type, name, data) {
  fbq(type, name, data);
}

function fbPushItemToItemsArray (array, id, admits) {
  var decodedArray = JSON.parse(array);

  decodedArray.push({
      id: id,
      quantity: admits
  });

  return JSON.stringify(decodedArray);
}
